export type SpotlightTileLayout = {
  /** Large horizontal card with description when true. */
  isSpotlight: boolean
  gridColumn: string | null
}

/**
 * Mosaic layout: 10-tile repeating cycle in a 3-column grid.
 * Wide slots: indices where i % 10 is 0 (left span 2) or 6 (right span 2).
 *
 * If `isPrimaryByIndex` is provided and has the same length as `count`, and at
 * least one index is primary: only primary tiles at wide slots use the
 * spotlight variant; other wide slots stay span-2 with the default card.
 * If none are primary, or flags are omitted: every wide slot uses the
 * spotlight variant.
 */
export const getSpotlightTileLayouts = (
  count: number,
  isMobile: boolean,
  isPrimaryByIndex?: readonly boolean[],
): SpotlightTileLayout[] => {
  if (count === 0 || isMobile) {
    return Array.from({ length: count }, (): SpotlightTileLayout => ({
      isSpotlight: false,
      gridColumn: null,
    }))
  }

  const usePrimary =
    isPrimaryByIndex !== undefined && isPrimaryByIndex.length === count
  const flags = usePrimary
    ? isPrimaryByIndex
    : Array.from({ length: count }, () => false)
  const hasAnyPrimary = flags.some(Boolean)

  return Array.from({ length: count }, (_, index): SpotlightTileLayout => {
    const cycle = index % 10
    const isWideLeft = cycle === 0
    const isWideRight = cycle === 6
    const wideSlot = isWideLeft || isWideRight
    const gridColumn = wideSlot
      ? isWideLeft
        ? '1 / span 2'
        : '2 / span 2'
      : null
    const isSpotlight =
      wideSlot && (Boolean(flags[index]) || !hasAnyPrimary || !usePrimary)
    return {
      isSpotlight,
      gridColumn,
    }
  })
}
